import { createFileRoute } from "@tanstack/react-router";
import { CrmLayout } from "@/components/crm/CrmLayout";

export const Route = createFileRoute("/_authenticated/app")({
  // El manifiesto deja instalar el CRM como app en Android, que es donde llegan los avisos push.
  head: () => ({
    meta: [
      { title: "CRM — SUSIEDAD" },
      { name: "robots", content: "noindex" },
      { name: "theme-color", content: "#0a0a0a" },
    ],
    links: [
      { rel: "manifest", href: "/crm.webmanifest" },
      { rel: "apple-touch-icon", href: "/app-icon-192.png" },
    ],
  }),
  component: CrmLayout,
});
